var loadingScripts = {};
export var injectExternalScript = function injectExternalScript(url) {
  loadingScripts[url] = document.querySelector("script[src=\"".concat(url, "\"]")) != null ? Promise.resolve(loadingScripts[url]) : new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.src = url;

    script.onload = function () {
      return resolve();
    };

    script.onerror = function () {
      return reject();
    };

    script.onabort = function () {
      return reject();
    };

    document.head.appendChild(script);
  });
  return loadingScripts[url];
};
export var injectExternalStylesheet = function injectExternalStylesheet(url) {
  return new Promise(function (resolve, reject) {
    var loadedFile = document.querySelector("link[href=\"".concat(url, "\"]"));

    if (loadedFile) {
      resolve();
    } else {
      var style = document.createElement('link');
      style.setAttribute('rel', 'stylesheet');
      style.href = url;

      style.onload = function () {
        return resolve();
      };

      style.onerror = function () {
        return reject();
      };

      style.onabort = function () {
        return reject();
      };

      document.head.appendChild(style);
    }
  });
};